import { render, staticRenderFns } from "./JwJiaocaiModal.vue?vue&type=template&id=c64da7d2"
import script from "./JwJiaocaiModal.vue?vue&type=script&lang=js"
export * from "./JwJiaocaiModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports